/*

INITIAL DRAFT

*/
// export const appIsLaunched = () => {}
// export const appIsReady = () => {
// 	return {
// 		type: 'APP_READY',
// 	}
// }
export var startLoading = function (pendingAction, loadingElem) {
    if (loadingElem === void 0) { loadingElem = 'full'; }
    return {
        type: 'app/startLoading',
        payload: {
            pendingAction: pendingAction,
            loadingElem: loadingElem,
        },
    };
};
export var resolveLoading = function (resolvedAction, loadingElem) {
    if (loadingElem === void 0) { loadingElem = 'full'; }
    return {
        type: 'app/resolveLoading',
        payload: {
            resolvedAction: resolvedAction,
            loadingElem: loadingElem,
        },
    };
};
export var startDragEvent = function (fileType) {
    return {
        type: 'app/startDragEvent',
        payload: {
            fileType: fileType,
        },
    };
};
export var toggleSidebar = function (state) {
    return {
        type: 'app/toggleNavbar',
        payload: state,
    };
};
export var resolveDragEvent = function () {
    return {
        type: 'app/resolveDragEvent',
    };
};
export var displayToastMessage = function () { };
